import { render, staticRenderFns } from "./AllRankCard.vue?vue&type=template&id=656d3a32&scoped=true&"
import script from "./AllRankCard.vue?vue&type=script&lang=js&"
export * from "./AllRankCard.vue?vue&type=script&lang=js&"
import style0 from "./AllRankCard.vue?vue&type=style&index=0&id=656d3a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d3a32",
  null
  
)

export default component.exports